module.exports = __webpack_public_path__ + "img/15-f61a76.png";